import type { Questionnaire } from '@medplum/fhirtypes'
import { VALIDATED_TOOL_TAG } from '#src/models/questionnaires/utils/index.ts'

export const ennQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/ENN',
  title: 'Estimated Nutritional Needs',
  name: 'ENN',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  item: [
    {
      type: 'decimal',
      linkId: 'weight',
    },
    {
      type: 'decimal',
      linkId: 'height',
    },
    {
      type: 'decimal',
      linkId: 'usual-body-weight',
    },
    {
      type: 'decimal',
      linkId: 'goal-weight',
    },
    {
      type: 'decimal',
      linkId: 'calorie-goal-min',
    },
    {
      type: 'decimal',
      linkId: 'calorie-goal-max',
    },
    {
      type: 'decimal',
      linkId: 'protein-goal-min',
    },
    {
      type: 'decimal',
      linkId: 'protein-goal-max',
    },
  ],
} satisfies Questionnaire
